import Transform from '@ember-data/serializer/transform'
import type { Type } from '@warp-drive/core-types/symbols'
import { DEFAULT_LANGUAGE, supportedLanguages } from 'teacher-ui-client/utils/locales'

// This is in a transform (rather than a getter on the model), in order to have it be deserialized into an appropriate
// string, before any other code uses it for anything.
export default class LanguageTagTransform extends Transform {
  deserialize(serializedLanguageTag?: string) {
    // Use lowercased, as casing does not carry value with language tags
    const lowercased = serializedLanguageTag?.toLowerCase()
    return lowercased && Object.keys(supportedLanguages).includes(lowercased) ? lowercased : DEFAULT_LANGUAGE
  }

  serialize(val?: string) {
    return val
  }

  declare [Type]: 'language-tag'
}
